import {AfterViewInit, Component, ElementRef, Input, ViewChild} from '@angular/core';
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";
import {ObjectFit} from "../../../ts-types/object-fit";
import {OverlayService} from "../../../overlay/overlay.service";

@Component({
  selector: 'brt-embed-video-youtube',
  templateUrl: './embed-video-youtube.component.html',
  styleUrls: ['./embed-video-youtube.component.scss']
})

export class EmbedVideoYoutubeComponent implements AfterViewInit {

  @Input('youtube-str') set setIframeStr(val: string) {
    this.src = val;

    let strNoIframe = (val.indexOf("iframe") === -1);
    if (strNoIframe) {
      // kinda youtube link — normalise watch/short URLs to the /embed/ player,
      // otherwise the iframe renders the full YouTube watch page (header, search,
      // recommended-videos sidebar) instead of just the player.
      const url = new URL(this.toYoutubeEmbedUrl(val));
      // url.searchParams.set("controls", "0");
      url.searchParams.set("rel", "0");
      url.searchParams.set("modestbranding", "0");
      url.searchParams.set("showinfo", "0");
      url.searchParams.set("autoplay", "1");
      // Browsers only allow unprompted autoplay when the player is muted, so mute
      // on start; the viewer can unmute via the player's own sound control.
      url.searchParams.set("mute", "1");
      url.searchParams.set("enablejsapi", "1");

      let iFrameSrc = url.toString();

      val = `<iframe id="youtube-player" width="16" height="9" src="${iFrameSrc}" allow="autoplay; fullscreen; encrypted-media; picture-in-picture" allowfullscreen referrerpolicy="strict-origin-when-cross-origin"></iframe>`
    } else {
      if (val.indexOf("strict-origin-when-cross-origin") === -1) {
        val = val.replace("<iframe", '<iframe referrerpolicy="strict-origin-when-cross-origin"');
      }
    }

    this.iframeStr = this.domSanitizer.bypassSecurityTrustHtml(val);

    // this.addPlayerControls();
  }

  // Convert any common YouTube URL form (watch?v=, youtu.be/, /shorts/) to the
  // embeddable player URL. Already-embed URLs and unparseable strings pass through.
  private toYoutubeEmbedUrl(raw: string): string {
    try {
      const url = new URL(raw);
      const host = url.hostname.replace(/^www\./, "");
      let id = "";
      if (host === "youtu.be") {
        id = url.pathname.slice(1);
      } else if (url.pathname.startsWith("/embed/")) {
        return raw;
      } else if (url.pathname.startsWith("/shorts/")) {
        id = url.pathname.split("/")[2] ?? "";
      } else {
        id = url.searchParams.get("v") ?? "";
      }
      return id ? `https://www.youtube.com/embed/${id}` : raw;
    } catch {
      return raw;
    }
  }

  @Input('object-fit') objectFit: ObjectFit = "contain";

  @ViewChild("mainEl") mainEl = new ElementRef(null);
  src = "";
  iframeStr: SafeHtml = "";

  constructor(
    private domSanitizer: DomSanitizer,
    private overlayService: OverlayService
  ) {
  }

  ngAfterViewInit() {
    if (this.objectFit === "contain") {
      if (this.mainEl.nativeElement) {
        const mainElHtml = this.mainEl.nativeElement as HTMLElement;
        const iframeEl = mainElHtml.querySelector("iframe");

        if (iframeEl) {
          const width = parseInt(iframeEl.getAttribute("width") ?? "0");
          const height = parseInt(iframeEl.getAttribute("height") ?? "0");
          mainElHtml.style.paddingBottom = `${height / width * 100}%`
          this.addPlayerControls();
        }
      }
    }
  }

  addPlayerControls() {
    // @ts-ignore
    if (typeof window["YT"] !== "undefined") {
      this.ytReady();
      return
    }
    const tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    const firstScriptTag = document.getElementsByTagName('script')[0];
    // @ts-ignore
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    // @ts-ignore
    window['onYouTubeIframeAPIReady'] = (e: any) => this.ytReady();
  }

  ytReady() {
    // @ts-ignore
    const player = new window["YT"].Player('youtube-player');
    if (player) {
      try {
        player.addEventListener("onStateChange", (e: any) => {
          if (e.data === 0) {
            this.overlayService.removeLastComponent();
          }
        });
      } catch (e: any) {
        console.warn(`Handled Exception 000001: ${e.message}`);
      }
    }
  }

}
